import type { User } from 'firebase/auth';

/** UI convenience only — Firestore independently enforces this restriction. */
export function canCreateFamily(user: Pick<User, 'email' | 'emailVerified'>): boolean {
  return user.email === 'francisco@dallarosa.me' && user.emailVerified;
}
